import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap, catchError, timeout } from 'rxjs/operators';
import { Storage } from '@ionic/storage';
import { ENV } from '@app/env';

import { HttpErrorHandlerProvider, HandleError } from '../http-error-handler/http-error-handler';

@Injectable()
export class AuthProvider {

  private handleError: HandleError;
  wsUrlLogin: string = ENV.wsUrl+'STSService/LoginService.svc/';
  apikey: string = ENV.apikey;

  constructor(public http: HttpClient, public storage: Storage, httpErrorHandler: HttpErrorHandlerProvider) {
    this.handleError = httpErrorHandler.createHandleError('AuthProvider');
  }

  ping(){
    return this.http.get(this.wsUrlLogin+'Ping')
    .pipe(
      timeout(5000),
      catchError(this.handleError('ping', false))
    )
  }

  login(loginParams){
    let params = "email="+loginParams.email+"&key="+this.apikey+"&preferredLanguage="+loginParams.selectedLanguage;
    return this.http.get(this.wsUrlLogin+'FFOLogin?'+params ,{ withCredentials: true})
    .pipe(
      tap(user => this.storage.set("user", user))
    )
  }

  loginWeb(loginParams){
    let params = "email="+loginParams.email+"&password="+loginParams.password+"&key="+this.apikey+"&preferredLanguage="+loginParams.selectedLanguage;
    return this.http.get(this.wsUrlLogin+'FFOLoginWeb?'+params ,{ withCredentials: true})
    .pipe(
      tap(user => this.storage.set("user", user))
    )
  }

  logout() {
    return this.http.get(this.wsUrlLogin+'Logout')
  }

  sendResetPassword(email){
    return this.http.get(this.wsUrlLogin+'SendPasswordResetEmail?email='+email);
  }

  resetPassword(formValues, token){
    return this.http.get(this.wsUrlLogin+'ResetPassword?email='+formValues.email+'&newPassword='+formValues.newPassword+'&token='+token);
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts